import React, { useEffect, useMemo } from "react";
import styles from "../AnalyticsCategory/index.module.css";
import myStyles from "./index.module.css";
import StackedBarChart from "../StackedBarChart";
import MultiselectDropdown from "../MultiselectDropdown";
import { categorySteps } from "../../../utils/constant";
import { useState } from "react";
import { Head, Row } from "../TableheadAndRow";
import DropDown from "../Dropdown";
import { rowCounts } from "../../../utils/constant";
import { useDispatch, useSelector } from "react-redux";
import { fetchPPBTrends } from "../../../store/slices/analytics/analytics.slice";
import { useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { filterAnalyticsLocationsByOrg } from "../../../utils/helpers";

const AnalyticsBrand = () => {
  const [selRowCount, setSelRowCount] = useState(0);
  const [graphData, setGraphData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [pageNo, setPageNo] = useState(0);
  const [brandSearch, setBrandSearch] = useState("");

  const dispatch = useDispatch();
  const ppbTrends = useSelector((store) => store.analytics.ppbTrends);
  const { brand: brandSteps, source } = useSelector((store) => store.constant);
  const locationSteps = useSelector((store) => store.constant.location);
  const organizationId = useSelector((store) => store.user.organizationId);
  
  const filteredLocationSteps = useMemo(() => {
    return filterAnalyticsLocationsByOrg(locationSteps, organizationId);
  }, [locationSteps, organizationId]);
  
  const [selectedCategories, setSelectedCategories] = useState(brandSteps);
  const [filteredDataLength, setFilteredDataLength] = useState(
    ppbTrends?.length
  );
  const [selectedLocations, setSelectedLocations] = useState(filteredLocationSteps || []);
  const navigate = useNavigate();

  useEffect(() => {
    if (filteredLocationSteps && filteredLocationSteps.length > 0) {
      setSelectedLocations(filteredLocationSteps);
    }
  }, [filteredLocationSteps]);

  useEffect(() => {
    dispatch(fetchPPBTrends({ selectedLocations, source }));
  }, [selectedLocations, source]);

  useEffect(() => {
    let data = [],
      headers = ["Category"],
      maxRank = 0;

    for (let i = 0; i < ppbTrends?.length; i++) {
      data.push({
        brand: ppbTrends[i]?.brand,
        cheapest: 0,
        midrange: 0,
        expensive: 0,
      });

      let last = 0;
      for (
        let j = 0;
        j < ppbTrends[i]?.pricerank_wise_product_count?.length;
        j++
      ) {
        if (j == 0)
          data[i].cheapest = parseInt(
            ppbTrends[i]?.pricerank_wise_product_count[j]
          );
        else {
          if (parseInt(ppbTrends[i]?.pricerank_wise_product_count[j]) != 0) {
            last = parseInt(ppbTrends[i]?.pricerank_wise_product_count[j]);
            if (j > maxRank) maxRank = j;
          }

          data[i].midrange += parseInt(
            ppbTrends[i]?.pricerank_wise_product_count[j]
          );
        }
      }

      data[i].midrange -= last;
      data[i].expensive = last;
    }

    let finalData = [];
    for (let i = 0; i < data?.length; i++) {
      if (
        selectedCategories.findIndex(
          (el) => el.toLowerCase() == data[i]?.brand
        ) != -1 &&
        (brandSearch == "" ||
          data[i]?.brand?.startsWith(brandSearch?.toLowerCase()))
      ) {
        finalData.push(data[i]);
      }
    }

    setGraphData(
      finalData?.slice(
        rowCounts[selRowCount] * pageNo,
        rowCounts[selRowCount] * (parseInt(pageNo) + 1)
      )
    );

    data = [];

    for (let i = 0; i <= maxRank; i++) {
      headers.push("Price Rank-" + (i + 1));
    }

    for (let i = 0; i < ppbTrends?.length; i++) {
      data.push({
        category: ppbTrends[i].brand,
        price_rank: [],
      });

      for (let j = 0; j <= maxRank; j++) {
        if (ppbTrends[i]?.pricerank_wise_product_count?.length <= j)
          data[i].price_rank.push(0);
        else
          data[i].price_rank?.push(
            parseInt(ppbTrends[i]?.pricerank_wise_product_count[j])
          );
      }
    }

    finalData = [];
    for (let i = 0; i < data?.length; i++) {
      if (
        selectedCategories.findIndex(
          (el) => el.toLowerCase() == data[i]?.category
        ) != -1 &&
        (brandSearch == "" ||
          data[i]?.category?.startsWith(brandSearch?.toLowerCase()))
      ) {
        finalData.push(data[i]);
      }
    }
    setTableHeaders(headers);
    setFilteredDataLength(finalData?.length);
    setTableData(
      finalData?.slice(
        rowCounts[selRowCount] * pageNo,
        rowCounts[selRowCount] * (parseInt(pageNo) + 1)
      )
    );
  }, [ppbTrends, selectedCategories, selRowCount, pageNo, brandSearch]);

  const onPageNoChange = (e) => {
    setPageNo(e?.currentTarget?.dataset?.idx);
  };

  const data = [
    {
      name: "Baileys",
      cheapest: 2,
      midrange: 0,
      expensive: 0,
    },
    {
      name: "Cointreau",
      cheapest: 1,
      midrange: 0,
      expensive: 0,
    },
    {
      name: "Kahlua",
      cheapest: 1,
      midrange: 0,
      expensive: 0,
    },
    {
      name: "Somrus",
      cheapest: 1,
      midrange: 0,
      expensive: 0,
    },
    {
      name: "Jagermeister",
      cheapest: 1,
      midrange: 0,
      expensive: 0,
    },
    {
      name: "Midori",
      cheapest: 1,
      midrange: 0,
      expensive: 0,
    },
    {
      name: "Johnnie walker",
      cheapest: 2,
      midrange: 0,
      expensive: 0,
    },

    {
      name: "Clinique",
      cheapest: 0,
      midrange: 2,
      expensive: 0,
    },
    {
      name: "Wild Ferns",
      cheapest: 1,
      midrange: 0,
      expensive: 0,
    },
    {
      name: "Calvin Klein",
      cheapest: 0,
      midrange: 1,
      expensive: 0,
    },
    {
      name: "Giorgio Armani",
      cheapest: 0,
      midrange: 0,
      expensive: 1,
    },
  ];

  const tableDataDemo = [
    {
      category: "Baileys",
      price1: 2,
      price2: null,
      price3: null,
      price4: null,
      price5: null,
    },
    {
      category: "Cointreau",
      price1: 1,
      price2: null,
      price3: null,
      price4: null,
      price5: null,
    },
    {
      category: "Kahlua",
      price1: 1,
      price2: null,
      price3: null,
      price4: null,
      price5: null,
    },
    {
      category: "Jagermeister",
      price1: 1,
      price2: null,
      price3: null,
      price4: null,
      price5: null,
    },
    {
      category: "Somrus",
      price1: 1,
      price2: null,
      price3: null,
      price4: null,
      price5: null,
    },
    {
      category: "Midori",
      price1: 1,
      price2: null,
      price3: null,
      price4: null,
      price5: null,
    },
    {
      category: "Johnnie Walker",
      price1: 2,
      price2: null,
      price3: null,
      price4: null,
      price5: null,
    },
    {
      category: "Calvin Klein",
      price1: null,
      price2: null,
      price3: null,
      price4: null,
      price5: 1,
    },
    {
      category: "Wild Ferns",
      price1: 1,
      price2: null,
      price3: null,
      price4: null,
      price5: null,
    },
    {
      category: "Clinique",
      price1: null,
      price2: null,
      price3: 2,
      price4: null,
      price5: null,
    },
  ];

  const onSelectedLocationChange = (value) => {
    setSelectedLocations(value);
  };
  const onSelectedCategoryChange = (value) => {
    setSelectedCategories(value);
  };
  const onSelectedRowCount = (value, index) => {
    setPageNo(0);
    setSelRowCount(index);
  };
  const skipPages = (e) => {
    setPageNo((parseInt(pageNo / 5) + 1) * 5);
  };
  const skipPagesReverse = (e) => {
    setPageNo((parseInt(pageNo / 5) - 1) * 5);
  };
  const onBrandSearchChange = (e) => {
    setPageNo(0);
    setBrandSearch(e?.currentTarget?.value);
  };

  return (
    <div className={styles["container"]}>
      {/* Heading */}
      <div className={styles["graph"]}>
        <div className={styles["heading"]}>
          <div className={styles["titleAndPriceType"]}>
            <h3>Compare prices per brand</h3>
            <div className={styles["priceType"]}>
              <span className={styles["cheapest"]}>
                <i class="bi bi-circle-fill"></i>
                <span>cheapest</span>
              </span>
              <span className={styles["midrange"]}>
                <i class="bi bi-circle-fill"></i>
                <span>midrange</span>
              </span>
              <span className={styles["expensive"]}>
                <i class="bi bi-circle-fill"></i>
                <span>expensive</span>
              </span>
            </div>
          </div>
          <div className={myStyles["searchAndCategory"]}>
            <div className={myStyles["search"]}>
              <input
                type="text"
                placeholder="Brand"
                onChange={onBrandSearchChange}
              />
              <i class="bi bi-search"></i>
            </div>
            <div className={styles["category"]}>
              <MultiselectDropdown
                steps={filteredLocationSteps}
                onChange={onSelectedLocationChange}
                // noLabel={true}
                name={"locations"}
              />
            </div>
            <div className={styles["category"]}>
              <MultiselectDropdown
                steps={brandSteps}
                onChange={onSelectedCategoryChange}
                name="brands"
              />
            </div>
          </div>
        </div>

        <div className={styles["barGraph"]}>
          <StackedBarChart
            url={"/dashboard/df-products"}
            data={graphData}
            blueLabel={"cheapest"}
            greyLabel={"midrange"}
            greenLabel={"expensive"}
            type={"brand"}
            location={selectedLocations}
          />
        </div>
      </div>

      {/* Table content.  */}
      <div className={styles["table"]}>
        <Head>
          {tableHeaders && tableHeaders?.map((header) => <span>{header}</span>)}
        </Head>

        {tableData.length === 0 ? (
          <div>
            {" "}
            <PulseLoader />{" "}
          </div>
        ) : (
          tableData.map((item, index) => (
            <Row
              islast={tableData.length - 1 == index ? true : false}
              key={index}
            >
              <span>{item.category}</span>
              {item?.price_rank?.map((el, idx) => (
                <span
                  onClick={() =>
                    navigate(
                      `/dashboard/df-products?brand=${
                        item.category
                      }&pricerank=${idx + 1}&location=${selectedLocations}`
                    )
                  }
                >
                  {el || "0"}
                </span>
              ))}
            </Row>
          ))
        )}

        {/* Row count and pagination. */}
        <div className={myStyles["rowCount"]}>
          <div className={myStyles["count"]}>
            <span>Row Count</span>
            <div className={myStyles["countDropdown"]}>
              <DropDown
                steps={rowCounts}
                selectedValue={selRowCount}
                onChange={onSelectedRowCount}
              />
            </div>
          </div>

          <div className={myStyles["pages"]}>
            {pageNo < 5 ? <></> : <span onClick={skipPagesReverse}>&lt;</span>}
            {new Array(
              parseInt(filteredDataLength / rowCounts[selRowCount]) + 1 || 0
            )
              .fill(1)
              ?.map((el, idx) =>
                idx >= parseInt(pageNo / 5) * 5 &&
                idx < parseInt(pageNo / 5 + 1) * 5 ? (
                  <span
                    className={pageNo == idx ? myStyles["selected"] : ""}
                    onClick={onPageNoChange}
                    data-idx={idx}
                  >
                    {idx + 1}
                  </span>
                ) : (
                  <></>
                )
              )}
            {filteredDataLength / rowCounts[selRowCount] <=
            (parseInt(pageNo / 5) + 1) * 5 ? (
              <></>
            ) : (
              <span onClick={skipPages}>&gt;</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsBrand;
